<template>
    <div>
        <p>Personne : <b class="text-primary">{{ leader.type }}</b></p>

        <p>Genre : <b class="text-primary">{{ leader.sex }}</b></p>
        <p><span v-if="leader.sex === 'Masculin'">Nom : </span> <span v-else>Nom de naissance : </span> <b class="text-primary">{{ leader.name.firstName }} <span v-if="leader.sex === 'Masculin'">{{ leader.name.lastName }}</span> <span v-else>{{ leader.name.birthName }}</span></b></p>

        <div v-if="leader.type === 'Physique'">
            <p>Statut marital: <b class="text-primary">{{ leader.maritalStatus }}</b></p>
						<p v-if="leader.maritalStatus === 'Mariée' && leader.sex === 'Féminin'">Nom marital : <b class="text-primary">{{ leader.name.maritalName }}</b></p>
            <p>Né le : <b class="text-primary" v-if="leader.birth.day">{{ leader.birth.day }}</b> <span v-if="leader.birth.day && leader.birth.city">à</span> <b class="text-primary">{{ leader.birth.city }}</b> <b class="text-primary" v-if="leader.birth.city && leader.birth.zipCode"> ({{ leader.birth.zipCode }})</b> <span v-if="leader.birth.day && leader.birth.country">en</span> <b class="text-primary">{{ leader.birth.country }}</b></p>
            <p>Nationalité : <b class="text-primary">{{ leader.birth.nationality }}</b></p>
            <p>Adresse : <b class="text-primary">{{ leader.address.place }}<span v-if="leader.address.place && leader.address.zipCode">,</span> {{ leader.address.zipCode }} {{ leader.address.city }}</b></p>
            <p>Prénom et nom de jeune fille de la mère : <b class="text-primary">{{ leader.motherName }}</b></p>
            <p>Prénom et nom du père : <b class="text-primary">{{ leader.fatherName }}</b></p>
        </div>

        <div v-else>
            <p>Nom de la société : <b class="text-primary">{{ leader.company.name }}</b></p>
            <p>Numéro RCS : <b class="text-primary">{{ leader.company.rcs }}</b></p>
            <p>Adresse du siège social : <b class="text-primary">{{ leader.company.headOffice.place }}<span v-if="leader.company.headOffice.place && leader.company.headOffice.zipCode">,</span> {{ leader.company.headOffice.zipCode }} {{ leader.company.headOffice.city }}</b></p>
            <p>Ville du Greffe : <b class="text-primary">{{ leader.company.headOffice.registry }}</b></p>
            <p>Capital social : <b class="text-primary">{{ leader.company.shareCapital }}</b></p>
            <p>Forme sociale : <b class="text-primary">{{ leader.company.socialForm }}</b></p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            leader : {
                type: Object,
                required: true
            }
        }
    }
</script>
